exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".NotificationUnsubscribe__content___2bxsb {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin: 80px 0;\n  padding: 0 20px; }\n  .NotificationUnsubscribe__content___2bxsb h2 {\n    font-size: 30px;\n    margin-bottom: 40px; }\n\n.NotificationUnsubscribe__button___3Iq40 {\n  margin-top: 12px;\n  background-color: #f94144;\n  height: 50px;\n  width: 150px;\n  border: none;\n  font-weight: 700;\n  line-height: 23px;\n  font-size: 15px;\n  color: #ffffff;\n  border-radius: 8px; }\n", ""]);

// exports
exports.locals = {
	"content": "NotificationUnsubscribe__content___2bxsb",
	"button": "NotificationUnsubscribe__button___3Iq40"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/containers/NotificationUnsubscribe/NotificationUnsubscribe.scss
// module id = 5075
// module chunks = 6